<div class="container-fluid" style="overflow: hidden;">



    <div class="card border-0 no-shadow mb-3" style="background: #F8F9FC">
        <div class="card-header text-white" style="background: #56A898;border-radius: 10px;">
            Create Challan
        </div>
        <div class="card-body">
            <form [formGroup]="formContainerUpload" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-sm-10">
                        <div class="form-row ">
                         
                            <div class="form-group col-sm-4 col-md-4 col-lg-3">
                                <label>Crop Year
                                </label>
                                <select id="state" class="  dropdown" name="user_state" formControlName="year"
                                [class.invalid]="!formContainerUpload.controls['year'].valid && formContainerUpload.controls['year'].touched">
                                <option value="">Choose Crop Year</option>

                                <option class='option' *ngFor='let year of yearList' [value]="year.crop_year">
                                    {{year.crop_year}}</option>
                            </select>




                            <div
                                *ngIf="!formContainerUpload.controls['year'].valid && (formContainerUpload.controls['year'].touched || isSubmitted)">
                                <div class="invalid-feedback" style="display: block;">Please enter crop year</div>
                            </div>
                                
                            </div>

                    

                        
                            <div class="form-group col-sm-8 col-md-6 col-lg-4">

                                <label>Division
                                </label>
                                <select id="state" class="  dropdown" name="user_state" (change)="onChangeDivision($event.target.value)"
                                formControlName="division"
                                [class.invalid]="!formContainerUpload.controls['division'].valid && formContainerUpload.controls['division'].touched"
                                >
                                <option value=""  >Choose Division</option>

                               <option class='option' *ngFor='let division of divisionsList' [value]="division.division_id">
                                   {{division.division_name}}</option>
                           </select>

                                
                            <div
                            *ngIf="!formContainerUpload.controls['division'].valid && (formContainerUpload.controls['division'].touched || isSubmitted)">
                            <div class="invalid-feedback" style="display: block;">Please Select division</div>
                        </div>
                                
                            </div>
                            
                            
                            <div class="form-group col-sm-4 col-md-4 col-lg-3">
                           <label>Division Challan Number</label>
                                <input class="form-control" placeholder="Division Challan Number" type="text"
                                formControlName="challan"
                                [class.invalid]="!formContainerUpload.controls['challan'].valid && formContainerUpload.controls['challan'].touched">
                            <div
                                *ngIf="!formContainerUpload.controls['challan'].valid && (formContainerUpload.controls['challan'].touched || isSubmitted)">
                                <div class="invalid-feedback" style="display: block;">Please enter Division Challan Number</div>
                            </div>


                        </div>


                        <div class="form-group col-sm-4 col-md-4 col-lg-3">

                            <label>Challan Type</label>

                            <select id="state" class="dropdown" 
                            formControlName="challanName"
                            [class.invalid]="!formContainerUpload.controls['challanName'].valid && formContainerUpload.controls['challanName'].touched"
                            (change)='getChallanCount($event)'>
                            <option value=""  >Choose Challan Type</option>

                           <option class='option' *ngFor='let challan of challanList' [value]="challan.challan_id">
                               {{challan.challan_name}}</option>
                       </select>
                        <div
                            *ngIf="!formContainerUpload.controls['challanName'].valid && (formContainerUpload.controls['challanName'].touched || isSubmitted)">
                            <div class="invalid-feedback" style="display: block;">Please Select challan Type</div>
                        </div>
                    </div>

                        <div class="form-group col-sm-4 col-md-4 col-lg-3">
                            <label>No. of Containers</label>

                            <input class="form-control" placeholder="Challan Count" readonly="true" type="text"
                                formControlName="challan_count" style="background-color: #dfdfdf;"
                                [class.invalid]="!formContainerUpload.controls['challan_count'].valid && formContainerUpload.controls['challan_count'].touched">
                            <div
                                *ngIf="!formContainerUpload.controls['challan_count'].valid && (formContainerUpload.controls['challan_count'].touched || isSubmitted)">
                                <div class="invalid-feedback" style="display: block;">Please enter Challan Count</div>
                            </div>
                        </div>
                        </div>

                        <div *ngIf="file && file.name && radioForm.value.batchProcess === 'Automatic'">{{file.name}}
                        </div>
                     
                        <div *ngIf="showFileUploadError">
                            No records found in the file uploaded
                            </div>
                        <div class="form-row " *ngIf="radioForm.value.batchProcess === 'Automatic'">
                            
                            <div class="form-group col-sm-9 col-md-7 col-lg-5" style="position: relative;" *ngIf="(formContainerUpload.value.year && formContainerUpload.value.division && formContainerUpload.value.challan && formContainerUpload.value.challanName && formContainerUpload.value.challan_count )">
                                <i class="fa fa-trash fa-lg fa-fw" (click)="deleteFile()"
                                    style="position: absolute;
                            right: -14px;
                            top: -14px;background: #DBDBDB;border-radius: 7px;font-size: 13px;padding: 10px;width: 28px;border-radius: 100px;height: 28px;"></i>
                                <i class="fa fa-info" title="Download Sample File" style="position:absolute;right:-22px;cursor: pointer;" aria-hidden="true" (click)="downloadFile()"></i>
                            
                                <label class="uploader items" ondragover="false;" [class.loaded]="loaded"
                                    [style.outlineColor]="dragging ? activeColor : baseColor"
                                    (dragenter)="handleDragEnter()" (dragleave)="handleDragLeave()"
                                    (drop)="handleDrop($event)">
                                    <div class="row " *ngIf="!loaded">
                                        <div class="col ">
                                            <p style="font-size: 12px;font-weight: 800;">Upload file</p>
                                        </div>
                                        <div class="col ">
                                            <i class="fa fa-upload fa-lg fa-fw"></i>
                                        </div>
                                    </div>
                                    <h6 *ngIf="loaded">{{filename}}</h6>
                                    <input type="file" name="file"
                                        accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        (change)="changeInput($event)">
                                </label>
                            </div>
                        </div>
                        <div class="container table-responsive p-0" *ngIf="radioForm.value.batchProcess === 'Manual'">
                            <div class="float-right mb-2">
                                <button type="button" class=" delete-button " (click)="addRow()">Add</button>
                            </div>
                        
                            <table class="table table-bordered ">    
                                <thead class="thead" style="border: 2px solid #3C675F;;color: #fff;">
                                    <tr style="background: #3C675F;">
                                            <th scope="col">S. No.</th>
                                            <th scope="col">Bag Number</th>
                                            <th scope="col">Class</th>
                                            <th scope="col">Net Weight (Kgs)</th>
                                            <th scope="col">Gross Weight (Kgs)</th>
    
                                            <th scope="col">Action</th>
    
                                        </tr>  
                                    </thead>    
                                    <tbody>    
                                         <tr *ngFor="let dynamic of dynamicArray; let i = index;">    
                                            <td >   
                                                {{i+1}}
                                              </td>  
                                            <td>    
                                              <input [(ngModel)]="dynamicArray[i].bagNumber" class="delete-button" [ngModelOptions]="{standalone: true}"
                                              type="number" />    
                                            </td>    
                                            <td>    
                                              <input [(ngModel)]="dynamicArray[i].class" class="delete-button" [ngModelOptions]="{standalone: true}"
                                              type="text" />    
                                            </td>    
                                            <td>    
                                              <input [(ngModel)]="dynamicArray[i].netWeight" class="delete-button" [ngModelOptions]="{standalone: true}"
                                              type="number"/>    
                                            </td> 
                                            <td>    
                                                <input [(ngModel)]="dynamicArray[i].grossWeight" class="delete-button"[ngModelOptions]="{standalone: true}"
                                                type="number"/>    
                                              </td> 
                                            <td  >   
                                                
                                                <button class="delete-button" *ngIf="dynamicArray.length  != 1" 
                                                (click)="deleteRow(i)">Delete</button>
                                                
                                              </td> 

                                                  
                                        </tr>    
                                           
                                    </tbody>    
                                </table>    
                              
                        
                        </div>





                        <div class="form-row mt-3">

                            <div class="form-group col-sm-9 col-md-6 col-lg-5">
                                <div class="text-center">
                                    <button class="btn btn-lg mr-2"
                                        style="background: #3C675F;border-radius: 50px;width: 120px;height: 34px;margin-bottom: 0;font-weight: lighter;padding: 0;">Submit</button>


                                </div>
                            </div>
                        </div>




                    </div>

                    <div class="col-sm-2">
                        <form [formGroup]="radioForm">
                            <div class="form-check" *ngFor="let order of orders">
                                <input formControlName="batchProcess" type="radio" [value]="order.name" (change)="onBatchProcess($event,order.name)" />
                                {{order.name}}
                            </div>
                        </form>
                    </div>

                </div>

            </form>



        </div>

    </div>


</div>
